<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-button icon="space-shuttle" @click="openIcon()">自定义Icon</ot-button>
            <ot-button icon="ship" @click="openCustom()">Custom</ot-button>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-button%20icon%3D%22space-shuttle%22%20%40click%3D%22openIcon()%22%3E%E8%87%AA%E5%AE%9A%E4%B9%89Icon%3C%2Fot-button%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-button%20icon%3D%22ship%22%20%40click%3D%22openCustom()%22%3ECustom%3C%2Fot-button%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%20%20%20%20methods%3A%20%7B%0A%20%20%20%20%20%20%20%20openIcon()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20this.%24otMessage(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20icon%3A%20'space-shuttle'%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20title%3A%20'%E8%BF%99%E6%98%AF%E4%B8%80%E6%9D%A1%E6%B6%88%E6%81%AF%E6%8F%90%E7%A4%BA'%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20theme%3A%20this.%24otTheme%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20%20%20openCustom()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20this.%24otMessage(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20icon%3A%20'ship'%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20message%3A%20'%3Ci%3E%E8%BF%99%E6%98%AF%E4%B8%80%E6%9D%A1%E6%94%AF%E6%8C%81%20HTML%20%E6%A0%87%E7%AD%BE%E7%9A%84%E6%B6%88%E6%81%AF%3C%2Fi%3E'%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20theme%3A%20this.%24otTheme%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
    methods: {
        openIcon() {
            this.$otMessage({
                icon: 'space-shuttle',
                title: '这是一条消息提示',
                theme: this.$otTheme,
            });
        },
        openCustom() {
            this.$otMessage({
                icon: 'ship',
                message: '<i>这是一条支持 HTML 标签的消息</i>',
                theme: this.$otTheme,
            });
        },
    },
};
</script>
